import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App, { preloadRoute } from "./App";
// Brand fonts, self-hosted from npm (were a render-blocking Google Fonts stylesheet).
// Vite fingerprints the files, so they get the year-long immutable cache.
import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/600.css";
import "@fontsource/oswald/700.css";
import "@fontsource/special-elite/400.css";
import "@fontsource/zilla-slab/300.css";
import "@fontsource/zilla-slab/400.css";
import "@fontsource/zilla-slab/500.css";
import "@fontsource/zilla-slab/600.css";
import "@fontsource/zilla-slab/700.css";
import "./index.css";

const root = document.getElementById("root")!;
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Every route ships prerendered HTML (scripts/prerender.tsx). Hydrate it instead of
// re-rendering from scratch, so the painted page (and its LCP image) stays put and
// becomes interactive without a full client render. Load this route's chunk first
// so hydration never suspends.
if (root.hasChildNodes()) {
  preloadRoute(location.pathname).then(() => ReactDOM.hydrateRoot(root, app));
} else {
  ReactDOM.createRoot(root).render(app);
}
